export { default as Img200 } from './processed/200/Mary-Shelley.jpg';
export { default as Img400 } from './processed/400/Mary-Shelley.jpg';
export { default as Imgthumb } from './processed/thumb/Mary-Shelley.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Mary-Shelley.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Mary-Shelley.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Muted": {
    "_rgb": [
      129,
      158,
      110
    ],
    "_population": 3,
    "_hsl": [
      0.26736111111111116,
      0.19834710743801653,
      0.5254901960784314
    ]
  },
  "LightMuted": {
    "_rgb": [
      198,
      180,
      180
    ],
    "_population": 85,
    "_hsl": [
      0,
      0.1363636363636363,
      0.7411764705882353
    ]
  },
  "DarkMuted": {
    "_rgb": [
      57,
      82,
      56
    ],
    "_population": 14,
    "_hsl": [
      0.3269230769230769,
      0.1884057971014493,
      0.2705882352941177
    ]
  },
  "Vibrant": {
    "_rgb": [
      0,
      0,
      0
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Mary-Shelley.js